import { IAppUserWithStats } from '../../../interfaces';

class AppUserWithStatsMapper {
    toPersistence(domainAppUser: IAppUserWithStats): any {
        return {
            id: domainAppUser.id,
            name: domainAppUser.name,
            phone: domainAppUser.phone,
            cpf: domainAppUser.cpf,
            total_taxes: domainAppUser.total_taxes,
            total_invoices: domainAppUser.total_invoices,
            total_tickets: domainAppUser.total_tickets,
            created_at: domainAppUser.created_at,
            updated_at: domainAppUser.created_at,
            last_access: domainAppUser.created_at,

        }
    }

    toDomain(persistenceAppUser: any): IAppUserWithStats {
        return {
            id: persistenceAppUser.id,
            name: persistenceAppUser.name,
            phone: persistenceAppUser.phone,
            cpf: persistenceAppUser.cpf,
            total_invoices: persistenceAppUser.total_invoices,
            total_taxes: persistenceAppUser.total_taxes,
            total_tickets: persistenceAppUser.total_tickets,
            last_access: persistenceAppUser.last_access,
            created_at: persistenceAppUser.created_at,
            updated_at: persistenceAppUser.updated_at,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AppUserWithStatsMapper();
